/**
 * ConeWorks — ouverture du Mega Menu « Nos produits » au clic (en plus du survol natif du thème).
 *
 * Le thème ouvre déjà les sous-menus au survol, au focus clavier et via le bouton de dévoilement, et les ferme avec
 * Échap. Ce petit module ajoute seulement :
 * - le clic sur le lien d'un élément qui possède un sous-menu : il ouvre le menu (au lieu de quitter la page) ;
 *   s'il est déjà ouvert par le survol, il le laisse ouvert (aucun conflit survol / clic) ;
 * - la fermeture au clic en dehors du menu.
 * Il réutilise le bouton de dévoilement du thème : la gestion du focus et des attributs ARIA reste celle du thème.
 * Le tiroir mobile (menu en accordéon) n'est pas concerné. Ctrl / Cmd / Maj + clic gardent leur sens habituel.
 */

const DISCLOSURE = 'button.menu-list__disclosure';

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const header = document.querySelector('#header-component');
  if (!(header instanceof HTMLElement) || header.dataset.menuStyle !== 'menu') return;

  const menu = target.closest('header-menu');

  if (menu) {
    const link = target.closest('a.menu-list__link');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const item = link.closest('.menu-list__list-item');
    const disclosure = item?.querySelector(DISCLOSURE);
    if (!(disclosure instanceof HTMLElement)) return;

    event.preventDefault();
    if (disclosure.getAttribute('aria-expanded') !== 'true') disclosure.click();
    return;
  }

  // Clic en dehors du menu : on referme le sous-menu resté ouvert.
  const open = document.querySelector(`header-menu ${DISCLOSURE}[aria-expanded="true"]`);
  if (open instanceof HTMLElement) open.click();
});
